import { useQuery } from "@tanstack/react-query";

const apiPathname = process.env.ONEVENT_API_PATHNAME || "";

function herculesUrl(consignmentNumber: string) {
	return `${apiPathname}/Hercules/GetEditabilityStatus/${encodeURIComponent(consignmentNumber)}`;
}

async function fetchSubmittedOrderEditability(consignmentNumber: string): Promise<boolean> {
	const response = await fetch(herculesUrl(consignmentNumber));

	if (!response.ok) {
		throw new Error(`Failed to fetch editability status: ${response.status} ${response.statusText}`);
	}

	const data = await response.json();

	if (typeof data === "boolean") {
		return data;
	}

	if (typeof data?.isEditable === "boolean") {
		return data.isEditable;
	}

	if (typeof data?.editable === "boolean") {
		return data.editable;
	}

	throw new Error("The editability response did not include a boolean result.");
}

export function useSubmittedOrderEditability(consignmentNumber?: string, enabled = true) {
	const query = useQuery<boolean, Error>({
		queryKey: ["submittedOrderEditability", consignmentNumber],
		queryFn: () => fetchSubmittedOrderEditability(consignmentNumber!),
		enabled: enabled && !!consignmentNumber,
		retry: false
	});

	return {
		...query,
		isEditable: query.data ?? false
	};
}
